@if (progress > 0) {
  <div class="form-group">
    <div class="progress">
      <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="progress">{{progress}}%
      </div>
    </div>
  </div>
}
